(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const variantInput = root.querySelector('.product-variant-id');
    const totalPrice = root.querySelector('[data-product-price]');
    const radios = root.querySelectorAll('[data-price]');
    const message = root.querySelector('[data-gift-message]');
    const counter = root.querySelector('[data-message-count]');
    const offset = root.querySelector('[data-recipient-offset]');
    const priceGrid = root.querySelector('.kw-gift-card__amount-grid');

    if (offset) offset.value = String(new Date().getTimezoneOffset());
    if (message && counter) message.addEventListener('input', () => { counter.textContent = `${message.value.length}/200`; });

    const syncPrice = (radio) => {
      const money = radio.closest('.kw-gift-card__amount')?.querySelector('[data-variant-money]');
      if (!money || !totalPrice) return;
      totalPrice.textContent = money.textContent.trim();
      totalPrice.className = 'money';
      if (money.classList.contains('buckscc-converted')) {
        totalPrice.classList.add('buckscc-converted', 'buckscc-money');
      }
      ['bucks-original', 'bucks-init', 'bucks-currency', 'bucks-current'].forEach((attribute) => {
        const value = money.getAttribute(attribute);
        if (value) totalPrice.setAttribute(attribute, value); else totalPrice.removeAttribute(attribute);
      });
    };

    const revealConvertedPrices = () => {
      const prices = [...root.querySelectorAll('[data-variant-money]')];
      if (prices.length && prices.every((price) => price.classList.contains('buckscc-converted'))) {
        root.classList.remove('is-currency-pending');
      }
    };

    radios.forEach((radio) => radio.addEventListener('change', () => {
      if (!radio.checked) return;
      variantInput.value = radio.value;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncPrice(radio);
      window.bucksCC?.reConvert?.();
      window.setTimeout(() => syncPrice(radio), 50);
    }));

    const selected = root.querySelector('[data-price]:checked');
    if (selected) syncPrice(selected);

    const observer = new MutationObserver(() => {
      const current = root.querySelector('[data-price]:checked');
      if (current) syncPrice(current);
      revealConvertedPrices();
    });
    if (priceGrid) observer.observe(priceGrid, {subtree:true, childList:true, characterData:true, attributes:true});

    revealConvertedPrices();
    window.setTimeout(() => root.classList.remove('is-currency-pending'), 1200);
  };

  document.querySelectorAll('[data-kw-gift-card]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-kw-gift-card]')));
})();
